import React from 'react'
import { Select } from 'antd';

export default function BtnSelectLang() {
  const lang = localStorage.getItem("lang")

  const handleMenuLang = (lang) => {
    localStorage.setItem("lang", lang)
    window.location.reload();
  };

  return (
    <Select
      className={`${(!lang || lang === 'en') ? 'mr-2' : "ml-2"}`}
      value={lang ? lang : 'en'}
      style={{ width: 90 }}
      onChange={handleMenuLang}
      options={[
        { value: 'en', label: 'English' },
        { value: 'fa', label: 'فارسی' },
      ]}
    />
  );
}
